<script setup lang="ts"></script>
<template>
  <section class="audience-section">
    <img
      class="audience-bg-image"
      src="./images/audience-pic1.png"
      alt="Picture"
    />
    <div class="audience-content-card">
      <div class="audience-description">
        Мы приглашаем всех, кто работает с коммерческой недвижимостью и
        инвестирует на этом рынке — от независимых агентов до крупных
        консалтинговых компаний, представителей Family offices и частных
        инвесторов
      </div>
    </div>
    <h2 class="audience-title">
      Кому подойдёт
      <br />
      Брокер Пасс
    </h2>
  </section>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.audience-section {
  position: relative;
  overflow: hidden;

  .audience-bg-image {
    width: 1760px;
    height: 2640px;
    position: absolute;
    left: calc(50% - 1440px / 2 - 79px);
    top: -966px;
    object-fit: cover;
    aspect-ratio: 1760/2640;

    @media (max-width: $mobile-view) {
      left: calc(50% - 600px);
    }
  }

  .audience-content-card {
    position: relative;
    background: #ffffff;
    padding: 30px;
    width: 564px;
    margin: 82px 0 82px calc(50% + 40px);
    max-width: calc(50% - 40px);

    @media (max-width: $tablet-view) {
      width: 564px;
      margin: 90px 0 90px calc(50% - 52px);
      max-width: calc(50% + 52px);
    }

    @media (max-width: $mobile-view) {
      width: calc(100% - 20px);
      max-width: none;
      margin: 144px 10px 40px;
    }

    .audience-description {
      @include font-regular;
      color: var(--chiness-black, #111111);
      font-size: 32px;
      line-height: 130%;

      @media (max-width: $tablet-view) {
        font-size: 18px;
      }
    }
  }

  .audience-title {
    @include font-regular;
    color: var(--white, #ffffff);
    text-align: left;
    font-size: 64px;
    line-height: 100%;
    position: absolute;
    left: calc(50% - 591px);
    top: 73px;
    width: 400px;
    margin: 0;

    @media (max-width: 1205px) {
      left: 20px;
      max-width: calc(50% - 150px);
    }

    @media (max-width: $tablet-view) {
      font-size: 46px;
      top: 120px;
      left: 30px;
      max-width: calc(50% - 180px);
    }

    @media (max-width: $mobile-view) {
      font-size: 32px;
      top: 40px;
      left: 20px;
      max-width: calc(100% - 40px);
    }
  }
}
</style>
